<app-header></app-header>

<main role="main" class="container-fluid">
  <router-outlet></router-outlet>
</main>

<app-footer></app-footer>
